<template>
  <router-view />
</template>
<script>
import store from '@/store'

export default {
  name: 'Lease',
  watch: {
    $route(to, from) {
      console.log('HouseList/Lease', {to})
      if (to.name === 'houseDetailLeasesInfo') {
        this.$store.dispatch('HouseList/Lease/getLease', to.params.id).then(() => {
          // const tenant = this.$store.getters['HouseList/Lease/getTenant']
        })
      }
    }
  },
}
</script>
